import React, { useEffect, useState } from 'react';
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
  Box,
  TextField,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { updateEndorsementFormData } from 'src/features/rfqDataSlice';

const ClausesRemark = ({ policyDetails }) => {
  const dispatch = useDispatch();

  const [isEditable, setIsEditable] = useState(false);

  const [ClausesRemarkData, setClausesRemarkData] = useState({
    ClausesRemark: false,
    ClausesRemarkValue: '',
  });

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;

    const valueFromPolicy = '';

    setIsEditable(checked);

    setClausesRemarkData({
      ClausesRemark: checked,
      ClausesRemarkValue: valueFromPolicy,
    });
  };

  useEffect(() => {
    dispatch(
      updateEndorsementFormData({
        clausesRemark: {
          isSelected: ClausesRemarkData?.ClausesRemark,
          oldValue: '',
          newValue: ''
        }
      })
    );
  }, [ClausesRemarkData, dispatch]);

  return (
    <>
      {policyDetails?.policyClauseJSON?.length > 0 && (
        <>
          <Box sx={{ mb: 1, display: 'flex', gap: 1 }}>
            <Typography
              variant="h5"
              className="heading"
              sx={{
                background: 'rgb(9 84 174)',
                color: '#fff',
                py: 1,
                fontWeight: 'bold',
                width: '100%',
                pl: 2,
              }}
            >
              Clauses 
            </Typography>
          </Box>

          <Grid container spacing={2} sx={{ pl: 2 }}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={ClausesRemarkData.ClausesRemark}
                    onChange={handleCheckboxChange}
                  />
                }
                label={
                  <Box>
                    {policyDetails?.policyClauseJSON
                      ?.filter((item) => item.clauseType === 'clause')
                      ?.map((item, index) => (
                        <Typography
                          key={item.uniqueId || item.id}
                          variant="body2"
                        >
                          {index + 1}. {item?.insurenceClause?.title || ''}
                        </Typography>
                      ))}
                  </Box>
                }
              />
            </Grid>



          </Grid>
        </>
      )}
    </>
  );
};

export default ClausesRemark;
